<template>
  <div class="row">
    <div class="col">
      <h4> {{ getImageUrls.length }} Photos and Videos</h4>
      <div class="card-columns">
        <photo-card v-for="(image, index) in getImageUrls"
                    :key="index"
                    :image-url="image"
                    :photos="getImageUrls"
                    :image-index="index"></photo-card>
      </div>
    </div>
  </div>
</template>

<script>
import photoCard from './PhotoCard.vue'

export default {
  components: {
    photoCard
  },
  props: {
    getImageUrls: Array
  }
}
</script>

<style scoped>
.card-columns {
  column-count: 2;
}

@media (max-width: 500px) {
  .card-columns {
    column-count: 1 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/business/subnavItems/Photos.vue